import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const wheelselogConfig: TSPConfig = {
  key: 'wheelselog',
  name: 'WheelsElog',
  imageName: 'wheelselog',
  category: TSPCategory.API_KEY,
  helpText:
    'Connect to WheelsElog by entering the API key from your WheelsElog account settings.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default wheelselogConfig;
